/* eslint-disable max-len */
import REEFQuestion from 'images/coin-pages/questions/reef.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const reefPage: ICoinPageData = {
  title: 'coin_820',
  description: 'coin_821',
  // description: 'coin_822',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Reef (REEF)' }) }} />
  ),
  questionsBlock: {
    image: REEFQuestion,
    questions: [
      {
        title: 'coin_823',
        answer: 'coin_824',
      },
      {
        title: 'coin_825',
        answer: 'coin_826',
      },
      {
        title: 'coin_827',
        answer: 'coin_828',
      },
      {
        title: 'coin_829',
        answer: 'coin_830',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Reef (REEF)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_831',
        text: ['coin_833'],
      },
      {
        title: 'coin_832',
        text: ['coin_834'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/category/reef/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/05/Gain-profit-5.png',
        imageAlt: 'Hold Reef & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
